// src/theme/ThemeProvider.tsx
import React from 'react';
import { Global, ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import theme, { globalStyles } from './theme'; // Importamos nuestro objeto de tema

interface CustomThemeProviderProps {
  children: React.ReactNode;
}

const ThemeProvider: React.FC<CustomThemeProviderProps> = ({ children }) => {
  return (
    <EmotionThemeProvider theme={theme}>
      <Global styles={globalStyles} />
      {children}
    </EmotionThemeProvider>
  );
};

export default ThemeProvider;
